<template>
  <div class="line-chart-container pt-5 pr-5">
    <LineChartGenerator
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :width="width"
      :height="height"
    />
  </div>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import ChartDataLabels from "chartjs-plugin-datalabels";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  ChartDataLabels
)

export default {
  name: "LineChart",
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    labels: {
      type: Array,
      required: true,
      default: () => []
    },
    datasetData: {
      type: Array,
      required: true,
      default: () => []
    },
    totalRegistered: {
      type: Number,
      default: 0,
    },
    percentData: {
    type: Array,
    required: false,
    default: () => []
  }
  },
  methods: {
    forceChartUpdate() {
      this.$forceUpdate();
    },
  },
  computed: {
    formattedLabels() {
      
      return this.labels;
    },
    
    chartData() {
      return {
        labels: this.formattedLabels,
        datasets: [
          {
            label: "No. of Candidates",
            backgroundColor: "#439AFF",
            data: this.datasetData,
            borderColor: '#439AFF',
            backgroundColor: 'transparent',
            pointBackgroundColor: '#439AFF99',
            pointBorderColor: '#439AFF99',
            pointRadius: 5,
            pointHoverRadius: 10
          },
        ],
      };
    },
    
  chartOptions() {
  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        position: "bottom",
        labels: {
          font: { size: 14 },
          usePointStyle: true,
          pointStyle: "rect",
          generateLabels: (chart) => {
            const datasets = chart.data.datasets;
            return datasets.map((dataset, i) => ({
              text: `${dataset.label}`,
              fillStyle: dataset.borderColor,
              strokeStyle: dataset.borderColor,
              lineWidth: 2,
              hidden: false,
              index: i,
              pointStyle: 'rect'
            }));
          }
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const datasetLabel = context.dataset.label || ""; // e.g., "No. of Candidates"
            const value = context.raw; // actual value
            const percent = this.percentData?.[context.dataIndex] || 0; // percentage
            return `${datasetLabel} ${value} (${percent}%)`;
          }
        }
      }
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { autoSkip: false, maxRotation: 0, minRotation: 0, font: { size: 11 } },
        beginAtZero: true,
      },
      y: {
        grid: { display: false },
        beginAtZero: true,
      },
    },
  };
}

  },
  watch: {
    labels(newLabels) {
      this.forceChartUpdate();
    },
    datasetData(newData) {
      this.forceChartUpdate();
    },
    totalRegistered() {
      this.forceChartUpdate();
    },
    activeTab() {
      this.forceChartUpdate();
    }
  }
};
</script>

<style scoped>
.line-chart-container {
  width: 100%;
  height: 100%;
  max-width: 100%;
  /*margin: auto;*/
  position: relative;
}

.line-chart-container canvas {
  height: 280px !important;
}
</style>
